/**
 * Single glass-card row used by the scroll-mode leaderboard. Adds a wrapper
 * View around the current-user row when the parent needs to measure it
 * (`onCurrentUserRowRef`).
 */

import { View } from 'react-native';
import { StaggeredFadeIn } from '../../shared/StaggeredFadeIn';
import { LeaderboardCard } from './LeaderboardCard';
import type { LeaderboardTeamVisual } from './LeaderboardCard.constants';
import type { LeaderboardEntry } from '../../../src/worldcup/types/worldcup.types';
import type { WorldCupFuturesOptions } from '../../../src/worldcup/helpers/worldcupPicksData.helper';

interface LeaderboardGlassRowItemProps {
  entry: LeaderboardEntry;
  index: number;
  onPressRow?: (entry: LeaderboardEntry) => void;
  onOpenMenu?: (entry: LeaderboardEntry) => void;
  menuTriggerRef?: (ref: View | null) => void;
  futuresOptions: WorldCupFuturesOptions | null;
  /** Flags (national teams) or kits (clubs); defaults to flags (AC-3.6). */
  teamVisual?: LeaderboardTeamVisual;
  onCurrentUserRowRef?: (ref: View | null) => void;
}

export function LeaderboardGlassRowItem({
  entry,
  index,
  onPressRow,
  onOpenMenu,
  menuTriggerRef,
  futuresOptions,
  teamVisual = 'flag',
  onCurrentUserRowRef,
}: LeaderboardGlassRowItemProps) {
  const card = (
    <LeaderboardCard
      entry={entry}
      onPressRow={onPressRow}
      futuresOptions={futuresOptions}
      onOpenMenu={onOpenMenu}
      menuTriggerRef={menuTriggerRef}
      teamVisual={teamVisual}
    />
  );

  if (entry.isCurrentUser && onCurrentUserRowRef) {
    return (
      <View ref={onCurrentUserRowRef}>
        <StaggeredFadeIn index={index}>{card}</StaggeredFadeIn>
      </View>
    );
  }
  return <StaggeredFadeIn index={index}>{card}</StaggeredFadeIn>;
}
